import { Model } from '@models'
import CREATE_ACTION_GOAL from '../graphql/createActionGoal'
import ACTION_GOAL_SUMMARIES from '../graphql/actionGoalSummaries'
import DELETE_ACTION_GOAL from '../graphql/deleteActionGoal'
import REPLACE_ACTION_GOAL from '../graphql/replaceActionGoal'
import reducers from './actionGoals.reducers'

export default class ActionGoals {
  namespace = 'actionGoals'

  state = {
    ...Model.defaultState,
    summariesByWeek: {},
  }

  effects = {
    create: Model.buildEffect({
      name: `${this.namespace}/create`,
      query: CREATE_ACTION_GOAL,
      caching: false,
      dataPath: 'createActionGoal',
    }),
    delete: Model.buildEffect({
      name: `${this.namespace}/delete`,
      query: DELETE_ACTION_GOAL,
      caching: false,
      dataPath: 'deleteActionGoal',
    }),
    replace: Model.buildEffect({
      name: `${this.namespace}/replace`,
      query: REPLACE_ACTION_GOAL,
      caching: false,
      dataPath: 'replaceActionGoal',
    }),
    fetchSummaries: Model.buildEffect({
      name: `${this.namespace}/fetchSummaries`,
      query: ACTION_GOAL_SUMMARIES,
      caching: false,
      dataPath: 'actionGoalSummaries',
      reducers: [{ name: 'updateActionGoalSummaries' }],
    }),
  }

  reducers = reducers
}
